import { Routes } from "@angular/router";
import { content } from "./shared/routes/routes";

import { LayoutComponent } from "./layout/layout.component";
import { MaintenanceGuard } from "./features/auth/guard/maintenance.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "homev2",
    loadComponent: () =>
      import("./components/home-v2/home-v2.component").then(
        (m) => m.HomeV2Component,
      ),
    canActivate: [MaintenanceGuard]},
  {
    path: "maintenance",
    loadComponent: () =>
      import("./features/maintenance/maintenance.component").then(
        (m) => m.MaintenanceComponent,
      )},
  {
    path: "",
    component: LayoutComponent,
    children: content,
    canActivate: [MaintenanceGuard]}];
